import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_TRANSPORT_NETWORK_INLCM_13 = {
  title: "Facility to add additional port and \nnetwork configurations.",
  subtitle: "Transport Network",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_335"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_333"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_transport_net_13_screen.png",
          imageStyle: { position: "absolute", bottom: "328px", right: "103px" },
        },
      ]}
      pageNumber={"ENG_334"}
    />
  ),
};
